import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import CustomLinkSanitizer from './custom-formats/custom-link-sanitizer.module';
import SourceCodeButton from './custom-formats/source-code.module';
import { debounceTime } from 'rxjs/operators';
import { merge, Subject } from 'rxjs';
import Quill from 'quill';
import {IndentStyle} from './custom-formats/indentAttributor.module';
import { AlignAttribute, AlignClass, AlignStyle } from 'quill/formats/align';
import {EditorTextChangeEvent} from 'primeng/editor';
import SpecialCharacters from './custom-formats/quill-special-character';
Quill.register(CustomLinkSanitizer, true);
Quill.register('modules/specialCharacters', SpecialCharacters);
Quill.register('modules/sourceCodeButton', SourceCodeButton);

Quill.register('formats/align/attribute', AlignAttribute, true);
Quill.register('formats/align/class', AlignClass, true);
Quill.register('formats/align/style', AlignStyle, true);
Quill.register('formats/indent', IndentStyle, true);

@Component({
  selector: 'app-prime-editor',
  templateUrl: './prime-editor.component.html',
  styleUrls: ['./prime-editor.component.scss']
})
export class PrimeEditorComponent implements OnInit {
  @Input() disabled = false;
  @Input() editorData: string;
  @Input() public form: UntypedFormGroup;
  @Input() public formCName: string;

  @Output() change = new EventEmitter();

  public sourceMode = false;
  private editorChangeSubject$ = new Subject<string>();
  constructor() { }

  ngOnInit(): void {
    merge(
      this.editorChangeSubject$.pipe(debounceTime(100)),
    ).subscribe((content: string) => {
      this.form.get(this.formCName)?.setValue(content);
    });
  }

  onEditorEnterPressed($event: KeyboardEvent): any {
    // Prevent other events on enter key press
    $event.preventDefault();
    $event.stopPropagation();
  }

  onEditorChange(event: any) {
    if (event.target.tagName === 'TEXTAREA' && event.target.value) {
      this.editorChangeSubject$.next(event.target.value); // Emit new content
    }
  }

  onTextChange($event: EditorTextChangeEvent) {
    if (this.hasIndentOperation($event.delta)) {
      this.editorChangeSubject$.next($event.htmlValue);
    }
  }

  hasIndentOperation(delta: any): boolean {
    return delta.ops.some((op: any) => op.attributes && typeof op.attributes.indent !== 'undefined' && op.attributes.indent == null);
  }
}
